import Vue from 'vue';
import config from '@/config/index';
export default {
    //列表页相关
    // 查询
    getDeviceTypePage(params) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/deviceCategory/page`,
            method: 'get',
            params
        })
    },
    // 新增设备类型
    addDeviceType(data) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/deviceCategory/add`,
            method: 'post',
            data
        })
    },
    // 获取设备类型详情
    getDeviceTypeDetail(params) {
        return Vue.axios.get(`${config.base_url}/roses-platform/deviceCategory/detail`, params);
    },
    // 获取设备类型下拉
    getDeviceTypeList() {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/deviceCategory/chose`,
            method: 'get',
        })
    }
}